
<div
  tabindex="0"
  :data-id="propertySection.client_id"
  data-type="Section"
  class="form-element builder-element property-section"
  :class="propertyClasses"
  v-on:focus="replaceIdInRoute($event, true)"
  @click.stop="replaceIdInRoute"
>
  <div class="title-bar">
    <icon :class="ObjectModelPropertyDefinition.getIcon(property_type)">
      <span class="sr-only">Focused Element: {{ObjectModelPropertyDefinition.getDisplayName(property_type)}}</span>
    </icon>
    <strong>
      {{ObjectModelPropertyDefinition.getDisplayName(property_type)}}
      <debug-sort-order :sortable="propertySection"/>
    </strong>
    <move-destroy
      :card="propertySection"
      @remove:card="handleRemove"
      class="suffix"
      :remove-enabled="removeEnabled"
      :remove-tooltip="removeTooltip"
    />
  </div>

  <row>
    <column class="row-title">
      <div :id="`scroll-to-label-${propertySection.client_id}`"/>
      <labelable
        ref="labelableComponent"
        v-on="$listeners"
        v-bind="$attrs"
        :is-selected="propertySection.isSelected"
        v-model="propertySection.label_title"
        placeholder="Enter a section name..."
      ></labelable>
    </column>
  </row>

  <div class="grid">
    <div>
      <template v-if="properties.length">
        <base-object-model-property
          v-for="property in properties"
          :key="property.client_id"
          :object-model-property="property"
        />
      </template>
      <empty-drag-zone v-else></empty-drag-zone>
    </div>
  </div>
</div>
